import { DungoWidget } from './widget';
import type { DungoWidgetConfig, DungoWidgetInstance } from './types';

export type {
  DungoWidgetConfig,
  DungoWidgetInstance,
  DungoWidgetSession,
  DungoWidgetTheme,
} from './types';

/**
 * API pública del widget.
 *
 * IIFE  -> expuesto como `window.DungoWidget`.
 * ESM   -> `import DungoWidget from 'dungo-widget'`.
 */
const api = {
  /** Crea e inserta el widget en la página. Devuelve la instancia controlable. */
  init(config: DungoWidgetConfig): DungoWidgetInstance {
    return new DungoWidget(config);
  },
};

export default api;
